export default __webpack_public_path__ + "static/media/Escalation-Ver2_1.65e80390.mp3";